import { RecordDetailsResult } from '../api/records.js'

// Check if the user has dataset access.
export const hasDatasetAccess = (userId: number, dataset: RecordDetailsResult['datasets'][number]) => {
  return dataset.datasetUsers.some((datasetUser) => datasetUser.userId === userId)
}

// Check if the user is a dataset owner.
export const isDatasetOwner = (userId: number, dataset: RecordDetailsResult['datasets'][number]) => {
  const isDatasetUser = dataset.datasetUsers.find((user) => user.userId === userId)

  return isDatasetUser?.isOwner
}
